import { useTheme } from "styled-components";
import React, { useMemo } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";
import { Box } from "../Box";
import { Tooltip } from "../Tooltip";
import { EmptyChart } from "./EmptyChart";
import { PopoverContents } from "./internal/PopoverContents";
import { doesPieChartHaveData, formattedLegendText, getDataFillColor, TRANSLATERISKS, } from "./helpers";
export const DonutChart = ({ cursor, data, endAngle, isAnimationActive, isRiskChart, emptyMessage, emptyMessageFontSize, noLegend, popoverContentsColumns = [], responsiveContainerHeight = "100%", responsiveContainerWidth = "100%", showPopover = true, startAngle, tooltip, }) => {
    const theme = useTheme();
    const { colors: { chartColors }, } = theme;
    const pieChartHasData = useMemo(() => (data === null || data === void 0 ? void 0 : data.length) && doesPieChartHaveData(data), [data]);
    // Sort
    if (pieChartHasData) {
        if (isRiskChart) {
            data.sort((a, b) => TRANSLATERISKS[b.name] - TRANSLATERISKS[a.name]);
        }
        else {
            data.sort((a, b) => {
                if (a.value > b.value)
                    return -1;
                if (a.value < b.value)
                    return 1;
                return 0;
            });
        }
    }
    const needsResponsiveContainer = typeof responsiveContainerWidth === "string" || typeof responsiveContainerHeight === "string";
    return pieChartHasData ? (React.createElement(Tooltip, { content: showPopover ? React.createElement(PopoverContents, { columns: popoverContentsColumns, pieData: data }) : undefined, variant: "table" },
        React.createElement(Box, { "data-testid": "donutChart", width: "100%" },
            React.createElement(ResponsiveContainer, { id: "rechartsDonutChartDiv", height: responsiveContainerHeight, width: needsResponsiveContainer ? responsiveContainerWidth : "100%" },
                React.createElement(PieChart, Object.assign({}, (needsResponsiveContainer
                    ? {}
                    : { height: responsiveContainerHeight, width: responsiveContainerWidth })),
                    React.createElement(Pie, { cursor: cursor, cx: "50%", cy: "50%", data: data, dataKey: "value", endAngle: endAngle, innerRadius: 30, isAnimationActive: isAnimationActive, nameKey: "name", outerRadius: 70, startAngle: startAngle, stroke: "none" }, data.map((entry, index) => (React.createElement(Cell, { key: `cell-${entry.name}`, fill: entry.fill ||
                            getDataFillColor({
                                entry,
                                index,
                                isRiskChart,
                                theme,
                            }) })))),
                    tooltip,
                    !noLegend && (React.createElement(Legend, { content: (props) => formattedLegendText({ chartColors, props }), wrapperStyle: { left: 0, width: "100%" } }))))))) : (React.createElement(Box, { "data-testid": "rechartsDonutChartNoData", style: { height: responsiveContainerHeight, width: responsiveContainerWidth } },
        React.createElement(EmptyChart, { emptyMessage: emptyMessage, emptyMessageFontSize: emptyMessageFontSize })));
};
